import { useNavigate } from 'react-router-dom';
import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  width: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  icon: React.ReactNode;
  color: string;
  url?: string;
};

const VerticalButton = (props: Props) => {
  const { width, sx, children, icon, color, url } = props;
  const navigate = useNavigate();
  const handleClick = (): void => {
    if (url) {
      navigate(url);
    }
  };

  return (
    <Button
      sx={{
        width: { width },
        mx: 'auto',
        my: 0,
        margin: '10px auto',
        padding: '50px 10px 20px 10px',
        textAlign: 'center',
        bgcolor: color,
        borderRadius: '10px 0px 0px 10px',
        position: 'relative',
        boxShadow: 2,
        minWidth: '60px',
        ...sx
      }}
      onClick={handleClick}
    >
      <Typography
        variant="subtitle1"
        component="span"
        sx={{
          color: baseColors.white,
          writingMode: 'vertical-rl'
        }}
      >
        {children}
      </Typography>
      <span style={{ position: 'absolute', top: 10 }}>{icon}</span>
    </Button>
  );
};

export default VerticalButton;
